export default "/_next/static/images/community-topbannerbg-mobile-2a9e3412b4b863e105d79ffa15917c39.jpg";